
import { fetchConToken } from "../../../helpers/fetch";
import { AppDispatch, RootState, store } from "../../store";
import { setEdicion } from "./edicionSlice";
import { UsuarioState, UsuariosState, logout } from '../usuario/usuarioSlice';
import { CursoState } from "../curso";

export const estadoEdicion = (edicion: Boolean) => {

    return async (dispatch: AppDispatch, getState: any) => {

        if (edicion) {
            return dispatch(setEdicion(false))
        }

        const { curso } = getState().curso;    
        
        try {
            const resp = await fetchConToken(`admin/edicion/${curso.cid}`);
            const body = await resp.json();

            if (body.ok) {
                const { edicion } = body;
                dispatch(setEdicion(edicion))
            } else {
                return dispatch(logout())
            }
        } catch (error) {
            console.log(error)
        }
    }
}